import { render, staticRenderFns } from "./bao-cao-cong-no.vue?vue&type=template&id=5248285c&"
import script from "./bao-cao-cong-no.vue?vue&type=script&lang=js&"
export * from "./bao-cao-cong-no.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../khoquangchau/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../khoquangchau/admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAppBar,VCard,VCardText,VContainer,VDataTable,VFlex,VIcon,VLayout,VToolbarTitle,VTooltip})
